import { LocalStorageService } from "./LocalStorageService"
import store from '../'
import { setLanguage } from '../actions/account/AccountAction';

export const LanguageService = {
  defaultSection: "general",
  defaultLang: 'en',

  // supportedLanguges: {
  //   'en': { id: Langages.ENG, name: "english", key: 'en', code: "us", translations: en }
  // },

  getSelectedLanguage: function () {
    // return LocalStorageService.get('selected_language');
    return store.getState().user.language;
  },


  getMomentLanguage: function (langCode) {
    const selectedLang = langCode || LanguageService.getSelectedLanguageFromLocalStorage();
    
    if (selectedLang) {
      switch (selectedLang) {
        case 'aeb':
          return 'ar-tn';
        case 'am':
          return 'en';
          case 'fa':
            return 'fa';
        case 'br':
          return 'pt-br'
        case 'cnr':
          return 'me'
        case 'hy':
          return 'hy-am'
        case 'pa':
          return 'pa-in'
        case 'ur-PK':
          return 'sd'
        case 'zh':
        case 'zh-CHT':
          return 'zh-cn'
        default:
          return selectedLang;
      }
    }
    return selectedLang;
  },

  getSelectedLanguageFromLocalStorage: function () {
    return LocalStorageService.get('selected_language');
  },

  getNormilizedLanguage: function () {
    const selectedLang = LanguageService.getSelectedLanguageFromLocalStorage();
    if (selectedLang) {
      switch (selectedLang) {
        case 'hy':
          return 'hy-am';
        case 'en':
          return 'en-gb';
        case 'ru':
          return 'ru-RU';
        case 'it':
          return 'it-IT';
        case 'fr':
          return 'fr-FR';
        case 'es':
          return 'es-ES';
        case 'tr':
          return 'tr-TR';
        case 'zh':
          return 'zh-CHT';
        case 'ja':
          return 'ja-JP';
        case 'fa':
          return 'fa-IR';
        case 'da':
          return 'da-DK';
        case 'ku':
          return 'Arab-IQ';
        case 'pt':
          return 'pt-PT';
        case 'th':
          return 'th-TH';
        default:
          return selectedLang;
      }
    }
    return LanguageService.defaultLang;
  },

  getNormilizedCalendarLanguage: function () {
    const selectedLang = LocalStorageService.get('selected_language');
    if (selectedLang) {
      switch (selectedLang) {
        case 'en':
          return 'en-GB';
        default:
          return selectedLang;
      }
    }
    return LanguageService.defaultLang;
  },

  setSelectedLanguage: function (langCode) {
    if (langCode) {
      LocalStorageService.set("selected_language", langCode);
      store.dispatch(setLanguage(langCode))
      document.documentElement.setAttribute("lang", LanguageService.getMomentLanguage());
    }
  },

  getTranslations: function (langKey) {
    const translations = store.getState().translations.data;
    return translations;
  },

  capitalize(s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  },

  getReadableKey(key) {
    let readableString = key ? key.replace(/[A-Z]/g, function (match, a, b) {
      const next = b[a + 1];
      const prev = b[a - 1];
      if (/[A-Z]/.test(prev) && /[A-Z]/.test(next)) {
        return match;
      } else if (/[A-Z]/.test(next)) {
        return " " + match;
      } else {
        return " " + match.toLowerCase();
      }
    }) : '';
    return LanguageService.capitalize(readableString.trim());
  },

  hasTranslation(translationKey, section, params = []) {
    let translation =  LanguageService.getTranslation(translationKey, section, params = []);
    translation = translation?.replace(/\s/g, '');
    return translation?.toLowerCase() != translationKey?.toLowerCase();
  },

  getTranslation(translationKey, section, params = []) {
    let translation;

    const selectedLang = LanguageService.getSelectedLanguage();

    const translationSection = section ? section : LanguageService.defaultSection;
    const translations = LanguageService.getTranslations(selectedLang);
    const isTranslationExists = translations && translations[translationSection] && translations[translationSection][translationKey] && translations[translationSection][translationKey] !== LanguageService.capitalize(translationKey);
    // const isGeneralTranslationExists = translations && translations[this.defaultSection] && translations[this.defaultSection][translationKey] && translations[this.defaultSection][translationKey] !== this.capitalize(translationKey);
    translation = isTranslationExists ? translations[translationSection][translationKey] :
      store.getState().translations.isLoading === false ? LanguageService.getReadableKey(translationKey) : '';
    if (isTranslationExists) {
      let i = 0;
      while (params.length) {
        translation = translation.replace(`{${i}}`, params[0]);
        i++;
        params.shift();
      }
    }
    return translation;
  },

  getDefaultBrowserLanguage(languages) {
    const defaultLanguage = languages.find(language => (language.iso == navigator.language) || (language.iso?.includes(navigator.language)));
    return defaultLanguage && defaultLanguage.id;
  }
}

  